export function TimelineResizeHandle({ onResize, currentHeight }: { onResize: (h: number) => void; currentHeight: number }) {
  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    const startY = e.clientY;
    const startHeight = currentHeight;

    const handleMove = (moveEvent: MouseEvent) => {
      const dy = startY - moveEvent.clientY;
      onResize(Math.max(80, Math.min(500, startHeight + dy)));
    };
    const handleUp = () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleUp);
    };
    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleUp);
  };

  return (
    <div
      onMouseDown={handleMouseDown}
      style={{
        height: 4,
        background: '#e2e8f0',
        cursor: 'ns-resize',
        flexShrink: 0,
      }}
    />
  );
}
